module.exports = __webpack_public_path__ + "Public/Home/staticmokao/img/part8-2.928dde3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022/part8-2.png
// module id = XF4I
// module chunks = 1